export default "__VITE_ASSET__BY0EvEsy__"